import React, { useState, useEffect } from "react";
// import { Modal } from "react-bootstrap";
import LoadingBar from "react-top-loading-bar";
import { useParams } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Paper,
} from "@mui/material";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Tooltip,
  Select,
  AppBar,
  Modal,
  Toolbar,
  Typography,
  Container,
  Box,
  FormControlLabel,
  Checkbox,
  Input,
  Grid,
  TextField,
  TableCell,
  TableBody,
  TableRow,
  Table,
  TableHead,
  FormHelperText,
  Radio
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { MANUAL_ROLLNO_CLIENTS } from "./manualRollNoClients";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const AddAdmission = () => {
 const [rollNoMode, setRollNoMode] = useState(() => {
  const clientCode = sessionStorage.getItem("clientCode") || "";
 return MANUAL_ROLLNO_CLIENTS.includes(clientCode.trim().toLowerCase())
    ? "manual"
    : "auto";
  });
  const [isSaving, setIsSaving] = useState(false);
  const [hostelRoomNo, setHostelRoomNo] = useState("");
  const [selectedHostelItems, setSelectedHostelItems] = useState([]);
  const [hostelAmount, setHostelAmount] = useState("");
  const [hostelMonth, setHostelMonth] = useState("");
  //nabil
  const [admissionCodeMode, setAdmissionCodeMode] = useState('auto');
  let navigate = useNavigate();
  const [isMaster, setIsMaster] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(1);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [showMissingFieldsModal, setShowMissingFieldsModal] = useState(false);
  const [selectedTransportItems, setSelectedTransportItems] = useState([]);
  const [transportAmount, setTransportAmount] = useState("");
  const [transportMonth, setTransportMonth] = useState("");
  //nabil
  const [financialYears, setFinancialYears] = useState([]);
  const [parentsDobChecked, setParentsDobChecked] = useState(false);
  const [regisData, setRegisData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [nationality, setNationality] = useState([]);
  const [religion, setReligion] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [ddlClass, setddlClass] = useState([]);
  const [ddlSection, setddlSection] = useState([]);
  const [rollNo, setRollNo] = useState("");
  const [occupation, setOccupation] = useState([]);
  const [gender, setGender] = useState([]);
  const [bloodgrp, setBloodgrp] = useState([]);
  const [concessionData, setConcessionData] = useState([]);
  const [month, setMonth] = useState([]);
  // const [isTransport, setIsTransport] = useState(false);
  const [isHostel, setIsHostel] = useState(false);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [caste, setCaste] = useState([]);
  const [duplicateRollNoMessage, setDuplicateRollNoMessage] = useState("");
  const [streams, setStreams] = useState([]);
  const [dialogMessage, setDialogMessage] = useState("");
  const [selectedStream, setSelectedStream] = useState("");
  const [copyStudentMobile, setCopyStudentMobile] = useState(false);
  const [copyStudentAddressForFather, setCopyStudentAddressForFather] = useState(false);
  const [copyStudentAddressForMother, setCopyStudentAddressForMother] = useState(false);
  const [selectedLanguageType, setSelectedLanguageType] = useState("");

  // transport
  const [isTransport, setIsTransport] = useState(false);
  const [selectedRouteID, setSelectedRouteID] = useState("");
  // const [transportAmount, setTransportAmount] = useState("");
  const [routes, setRoutes] = useState([]);
  const [routeMessage, setRouteMessage] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [seatExceeded, setSeatExceeded] = useState(false);

  // const [transportMonth, setTransportMonth] = useState("");

  const [registrationData, setRegistrationData] = useState({
    admissionNo: "", // Added,
    StudentLedgerNo: "",
    admissionDate: "",
    financialYearID: "",
    registrationNo: "",
    registrationId: 0, // Already present
    dated: "",
    name: "",
    lname: "",
    classId: "",
    sectionId: "",
    className: "", // Already present
    sectionName: "", // Already present
    newRollNo: "",
    dob: "",
    age: "",
    email: "",
    adharNO: "",
    CertiNo: "", // Maps to TrfCertificationNo
    mobileNo: "",
    address: "",
    nationalityId: "",
    religionID: "",
    countryId: "",
    stateId: "",
    cityId: "",
    genderId: "",
    casteId: "",
    bloodGroupId: "",
    lastSchoolAttended: "", // Added
    paymentType: "0",
    studentUserName: "", // Added
    isHostel: false, // Added (boolean)
    isTransport: false, // Added (boolean)
    isAdmissionNoManual: false, // Added (boolean)
    routeId: 0, // Added
    pickAndDropLocationId: 0, // Added
    studentAnualPack: "", // Added
    fatherName: "",
    fdob: "",
    mdob: "",
    ews: "0",
    annualAmount: "",
    MotherName: "",
    fatherMobile: "",
    MotherMobile: "",
    Femail: "",
    Memail: "",
    grandFather: "",
    FIncome: "", // Already present, maps to FatherIncome
    MIncome: "", // Already present, maps to MotherIncome
    FAadhar: "",
    MAadhar: "",
    Faddress: "",
    Maddress: "",
    parentsDobChecked: false,
    Motheroccupation: "", // Maps to MotherOccupationId
    FatheroccupationID: "", // Maps to FatherOccupationId
    studentprofile: null,
    motherprofile: null,
    fatherprofile: null,
    aadharCardFront: null,
    aadharCardBack: null,
    birthCertificate: null,
    transferCertificate: null,
    others: null,
  });

  const resetForm = () => {
    const today = new Date().toISOString().split("T")[0];
    setRegistrationData({
      admissionDate: today,
      StudentLedgerNo: "",
      financialYearID: "",
      registrationNo: "",
      registrationId: 0,
      dated: "",
      name: "",
      lname: "",
      classId: "",
      sectionId: "",
      newRollNo: "",
      dob: "",
      age: "",
      email: "",
      adharNO: "",
      CertiNo: "",
      mobileNo: "",
      address: "",
      nationalityId: "",
      religionID: "",
      countryId: "",
      stateId: "",
      cityId: "",
      genderId: "",
      casteId: "",
      bloodGroupId: "",
      lastSchoolAttended: "",
      paymentType: "0", // Reset to default "0"
      fatherName: "",
      fdob: "",
      mdob: "",
      ews: "",
      isTransport: "",
      isHostel: "",
      annualAmount: "",
      MotherName: "",
      fatherMobile: "",
      MotherMobile: "",
      Femail: "",
      Memail: "",
      grandFather: "",
      FIncome: "",
      MIncome: "",
      FAadhar: "",
      MAadhar: "",
      Faddress: "",
      Maddress: "",
      parentsDobChecked: false,
      Motheroccupation: "",
      FatheroccupationID: "",
      studentprofile: null,
      motherprofile: null,
      fatherprofile: null,
      aadharCardFront: null,
      aadharCardBack: null,
      birthCertificate: null,
      transferCertificate: null,
      others: null,
    });
    setParentsDobChecked(false);
    setRollNo("");
    setSelectedStream("");
    setHostelRoomNo("");
    setSelectedItems([]);
    setIsTransport(false);
    setIsHostel(false);
    setCopyStudentMobile(false);
    setCopyStudentAddressForFather(false);
    setCopyStudentAddressForMother(false);
    setAdmissionCodeMode('auto');
    setErrors({
      financialYearID: false,
      name: false,
      classId: false,
      sectionId: false,
      mobileNo: false,
      religionID: false,
      nationalityId: false,
      dob: false,
      age: false,
      fatherName: false,
      MotherName: false,
      FatheroccupationID: false,
      casteId: false,
      fatherMobile: false,
      rollNo: false,
    });
  };

  const [errors, setErrors] = useState({
    financialYearID: false,
    name: false,
    classId: false,
    sectionId: false,
    mobileNo: false,
    religionID: false,
    nationalityId: false,
    dob: false,
    age: false,
    fatherName: false,
    MotherName: false,
    FatheroccupationID: false,
    casteId: false,
    fatherMobile: false,
    adharNO: false,
  });

// Merges new items into existing list, replacing any item that shares the same key
const mergeByKey = (prevItems, newItems, keyFn) => {
  const map = new Map(prevItems.map(item => [keyFn(item), item]));
  newItems.forEach(item => map.set(keyFn(item), item));
  return Array.from(map.values());
};

const handleAddHostelItem = () => {
  if (hostelMonth && hostelAmount && !isNaN(hostelAmount)) {
    let itemsToAdd = [];

    if (registrationData.paymentType === "1") {
      itemsToAdd.push({
        month: "All",
        monthId: 0,           // Annual = 0
        amount: parseFloat(hostelAmount),
        roomNo: hostelRoomNo,
      });
    } else {
      if (hostelMonth === "All") {
        itemsToAdd = month.map(item => ({
          month: item.month,
          monthId: item.monthId,   // store monthId from the month list
          amount: parseFloat(hostelAmount),
          roomNo: hostelRoomNo,
        }));
      } else {
        const selectedMonthObj = month.find(m => m.month === hostelMonth);
        itemsToAdd.push({
          month: hostelMonth,
          monthId: selectedMonthObj?.monthId || 0,   // store monthId
          amount: parseFloat(hostelAmount),
          roomNo: hostelRoomNo,
        });
      }
    }

 // ✅ this line MUST stay inside the function, right after itemsToAdd is built
    setSelectedHostelItems(prev =>
      mergeByKey(prev, itemsToAdd, item => `${item.month}`)
    );
    
    if (registrationData.paymentType === "0") setHostelMonth("");
    setHostelAmount("");
    setHostelRoomNo("");
  }
};

  const handleDeleteHostelItem = (index) => {
  setSelectedHostelItems(prev => prev.filter((_, i) => i !== index));
};

  // Handler for copying student's mobile number to father's mobile number
  const handleCopyStudentMobileChange = (e) => {
    const isChecked = e.target.checked;
    setCopyStudentMobile(isChecked);
    if (isChecked) {
      setRegistrationData({
        ...registrationData,
        fatherMobile: registrationData.mobileNo,
      });
    } else {
      setRegistrationData({
        ...registrationData,
        fatherMobile: "",
      });
    }
  };

  const fetchBranches = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        const data = await response.json();
        setBranches(data);
      } else {
        console.error("Failed to fetch branches");
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  const fetchRoutes = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Transportation/Route/routesdropdown`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) throw new Error(`Error fetching routes: ${response.status}`);

      const data = await response.json();

      // Filter out any empty or invalid responses
      const validRoutes = Array.isArray(data?.routes) ? data.routes : [];

      setRoutes(validRoutes); // Define state variable: const [routes, setRoutes] = useState([]);
    } catch (error) {
      console.error("Error fetching routes:", error);
      // alert("Failed to load transport routes.");
      setSnackbarMessage("Failed to load transport routes.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  // Handler for copying student's address to father's address
  const handleCopyStudentAddressForFatherChange = (e) => {
    const isChecked = e.target.checked;
    setCopyStudentAddressForFather(isChecked);
    if (isChecked) {
      setRegistrationData({
        ...registrationData,
        Faddress: registrationData.address,
      });
    } else {
      setRegistrationData({
        ...registrationData,
        Faddress: "",
      });
    }
  };

  // Handler for copying student's address to mother's address
  const handleCopyStudentAddressForMotherChange = (e) => {
    const isChecked = e.target.checked;
    setCopyStudentAddressForMother(isChecked);
    if (isChecked) {
      setRegistrationData({
        ...registrationData,
        Maddress: registrationData.address,
      });
    } else {
      setRegistrationData({
        ...registrationData,
        Maddress: "",
      });
    }
  };

  // nabil added useeffect for concession annual

  useEffect(() => {
    const isMasterUser = sessionStorage.getItem("is_Master") === "true";
    setIsMaster(isMasterUser);

    if (isMasterUser) {
      fetchBranches();
    } else {
      const branchId = sessionStorage.getItem("branchId");
      setSelectedBranchId(branchId);
    }
  }, []);


  useEffect(() => {
    if (registrationData.paymentType === "1") {
      // Annual payment - set month to "All" and disable changing it
      setSelectedMonth("All");
    } else {
      // General payment - reset month selection
      setSelectedMonth("");
    }
  }, [registrationData.paymentType]); //nabil

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // Format the date as YYYY-MM-DD
    setRegistrationData((prevData) => ({
      ...prevData,
      admissionDate: currentDate,
    }));
  }, []);

  const [selectedConcession, setSelectedConcession] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [openDialog, setOpenDialog] = useState(false); // Control dialog visibility

  //nabil
  //nabil
  const handleAddTransportItem = () => {
    if (selectedRouteID && transportMonth && transportAmount && !isNaN(transportAmount)) {
      const selectedRoute = routes.find(route => route.routeID === parseInt(selectedRouteID));
      const selectedMonthObj = month.find(m => m.month === transportMonth);

      if (selectedRoute) {
        let itemsToAdd = [];

        if (registrationData.paymentType === "1") {
          // Annual payment - create just one item for all months
          itemsToAdd.push({
            routeId: selectedRoute.routeID,
            routeName: selectedRoute.routeName,
            month: "All",
            monthId: 0,
            amount: parseFloat(transportAmount),
            distance: selectedRoute.distance
          });
        } else {
          // General payment logic remains the same
          if (transportMonth === "All") {
            itemsToAdd = month.map(item => ({
              routeId: selectedRoute.routeID,
              routeName: selectedRoute.routeName,
              month: item.month,
              monthId: item.monthId,
              amount: parseFloat(transportAmount),
              distance: selectedRoute.distance
            }));
          } else {
            itemsToAdd.push({
              routeId: selectedRoute.routeID,
              routeName: selectedRoute.routeName,
              month: transportMonth,
              monthId: selectedMonthObj.monthId,
              amount: parseFloat(transportAmount),
              distance: selectedRoute.distance
            });
          }
        }

setSelectedTransportItems(prev =>
  mergeByKey(prev, itemsToAdd, item => `${item.month}`)
);
        // Clear inputs
        if (registrationData.paymentType === "0") {
          setSelectedRouteID("");
        }
        setTransportAmount("");
        setTransportMonth("");
      }
    }
  };
  //nabil

  const handleDeleteTransportItem = (index) => {
    setSelectedTransportItems(prev => prev.filter((_, i) => i !== index));
  };//nabil

  const handleAddItem = () => {
    if (
      selectedConcession &&
      (selectedMonth || registrationData.paymentType === "1") && // Allow empty month if paymentType is annual
      selectedAmount &&
      !isNaN(selectedAmount)
    ) {
      const selectedConcessionObject = concessionData.find(
        (item) => item.concessionName === selectedConcession
      );

      if (selectedConcessionObject) {
        let itemsToAdd = [];

        if (registrationData.paymentType === "1") {
          // Annual payment - create just one item for all months
          itemsToAdd.push({
            concessionId: selectedConcessionObject.concessionId,
            concession: selectedConcession,
            month: "All",
            amount: parseFloat(selectedAmount),
          });
        } else {
          // General payment logic remains the same
          if (selectedMonth === "All") {
            itemsToAdd = month.map((item) => ({
              concessionId: selectedConcessionObject.concessionId,
              concession: selectedConcession,
              month: item.month,
              amount: parseFloat(selectedAmount),
            }));
          } else {
            itemsToAdd.push({
              concessionId: selectedConcessionObject.concessionId,
              concession: selectedConcession,
              month: selectedMonth,
              amount: parseFloat(selectedAmount),
            });
          }
        }

setSelectedItems(prevItems =>
  mergeByKey(prevItems, itemsToAdd, item => `${item.concessionId}-${item.month}`)
);
        // Clear selected values after adding item
        setSelectedConcession("");
        setSelectedAmount("");
        if (registrationData.paymentType !== "1") {
          setSelectedMonth(""); // Only clear month if not annual payment
        }
      }
    }
  };

  const handleDeleteItem = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleTransportChange = (e) => {
    const isChecked = e.target.checked;
    setIsTransport(isChecked);
    setRegistrationData((prev) => ({
      ...prev,
      isTransport: isChecked,
    }));
  };

  const handleHostelChange = (e) => {
    setIsHostel(e.target.checked);
  };

  const handleFileChange = (fieldName, event) => {
    const file = event.target.files[0]; // Get the selected file
    const fileSizeKB = file.size / 1024; // Convert file size to KB
    if (fileSizeKB > 200) {
      // If file size exceeds 200KB, show an alert
      // alert("File size exceeds the limit of 200KB.");
      setSnackbarMessage("File size exceeds the limit of 200KB.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      event.target.value = null; // Clear the file input
      return;
    }
    // Proceed with updating registration data
    setRegistrationData((prevData) => ({
      ...prevData,
      [fieldName]: file,
    }));
  };

  // const handleClassChange = (e) => {
  //     const selectedClassId = e.target.value;
  //     setRegistrationData((prevData) => ({
  //         ...prevData,
  //         classId: selectedClassId,
  //     }));
  // };

  // const handleSectionChange = (e) => {
  //     const selectedSectionId = e.target.value;
  //     setRegistrationData((prevData) => ({
  //         ...prevData,
  //         sectionId: selectedSectionId,
  //     }));
  // }

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [day, month, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`; // Returns YYYY-MM-DD
  };

  const handleClassChange = (e) => {
    const selectedClassId = e.target.value;
    const selectedClassName = ddlClass.find(
      (classItem) => classItem.classId === selectedClassId
    )?.className;
    setRegistrationData((prevData) => ({
      ...prevData,
      classId: selectedClassId,
      className: selectedClassName || "",
      sectionId: "",
    }));
    setddlSection([]); // Clear existing sections
    fetchddlSection(); // Fetch new sections
  };

  const handleSectionChange = (e) => {
    const selectedSectionId = e.target.value;
    const selectedSectionName = ddlSection.find(
      (sectionItem) => sectionItem.sectionId === selectedSectionId
    )?.sectionName;
    setRegistrationData((prevData) => ({
      ...prevData,
      sectionId: selectedSectionId,
      sectionName: selectedSectionName || "",
    }));
  };

  const handleRowSelection = async (selectedRegistration, registrationId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/Admission/GetStudentDetails_Regid`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            regId: registrationId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching student details: ${response.status}`);
      }

      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return;
      }

      const studentData = data[0];

      // Find the nationalityId based on the nationality name
      const selectedNationality = nationality.find(
        (n) => n.nationality === studentData.nationality
      );
      const nationalityId = selectedNationality
        ? selectedNationality.nationalityId
        : "";

      // Format the registration date to YYYY-MM-DD
      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        // Assuming date comes as DD/MM/YYYY from API
        const [day, month, year] = dateStr.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      };

      setRegistrationData((prevData) => ({
        ...prevData,
        registrationNo: studentData.registrationNo || "",
        registrationId: studentData.registrationId,
        dated: formatDate(studentData.dated) || "", // Format the date correctly
        name: studentData.studentFirstName || "",
        fatherName: studentData.fatherName || "",
        dob: formatDateForInput(studentData.studentDOB) || "",
        age: studentData.studentAge.toString() || "",
        genderId: studentData.genderId || "",
        nationalityId: nationalityId || "",
        mobileNo: studentData.studentMobile || "",
        email: studentData.emailId || "",
        address: studentData.address || "",
        adharNO: studentData.studentAdhaarNo || "",
        classId: studentData.classId || "",
        countryId: studentData.countryId || "",
        stateId: studentData.stateId || "",
        cityId: studentData.cityID || "",
        grandFather: studentData.grandFather || "",
      }));

      handleClose();
    } catch (error) {
      console.error("Error in handleRowSelection:", error);
      handleClose();
    }
  };

  const fetchFinancialYears = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/ClassPromotion/GetFinancialYear`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }

      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }
      setFinancialYears(data);

      // Calculate the current financial year based on the system date
      const today = new Date();
      const currentYear = today.getFullYear();
      const nextYear = currentYear + 1;

      // Determine the financial year
      const financialYearStart = new Date(currentYear, 3, 1); // April 1st of the current year
      const financialYearEnd = new Date(nextYear, 2, 31); // March 31st of the next year

      let currentSessionString;
      if (today >= financialYearStart && today <= financialYearEnd) {
        // Current date falls in the financial year (e.g., April 1, 2024 - March 31, 2025)
        currentSessionString = `${currentYear}-${nextYear}`;
      } else {
        // Current date falls in the previous financial year (e.g., January 1, 2024 - March 31, 2024)
        currentSessionString = `${currentYear - 1}-${currentYear}`;
      }

      // Find the session that matches the current financial year
      const currentSession = data.find(
        (item) => item.finanacialYear === currentSessionString
      );

      if (currentSession) {
        setRegistrationData((prevData) => ({
          ...prevData, // Preserve the existing fields in registrationData
          financialYearID: currentSession.financialYearID, // Set the financialYearID
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getCurrentYear = () => {
    return new Date().getFullYear().toString();
  };

  const fetchRegistration = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/FetchReg_Admission`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        // alert("Record Not Found");
        setSnackbarMessage("Record Not Found");
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
        return; // Exit the function if the record is not found
      }
      setRegisData(data);
      handleShow(); // Open the modal after fetching data
      //setSelectedValue(data[0]); // Assuming the API returns an array of options
    } catch (error) {
      console.error(error);
    }
  };

  const fetchNationalityData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Nationality/GetNationality`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching nationality data: ${response.status}`);
      }

      const data = await response.json();
      console.log("Nationality Data:", data); // Add this to inspect the response
      setNationality(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchReligionData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Religion/GetReligion`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const religionData = await response.json();

      if (
        religionData.data === null &&
        religionData.msg === "Record Not Found"
      ) {
        return; // Exit the function if the record is not found
      }

      setReligion(religionData);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchCountry = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCountry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        return; // Exit the function if the record is not found
      }

      setCountry(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchOcccupation = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Occupation/GetOccupation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setOccupation(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  // anual payment handle
  useEffect(() => {
    if (isTransport && selectedRouteID) {
      const selectedRoute = routes.find(route => route.routeID === parseInt(selectedRouteID));

      if (selectedRoute) {
        if (registrationData.paymentType === "1") {
          // Annual payment - set to all months and 12*charge
          setTransportMonth("All");
          const annualTransportAmount = (selectedRoute.routeCharge * 12).toString();
          setTransportAmount(annualTransportAmount);
          // Remove this line: we don't want to update studentAnualPack here
          // setRegistrationData(prev => ({ ...prev, studentAnualPack: annualAmount }));
        } else {
          // General payment - set to single month charge
          setTransportAmount(selectedRoute.routeCharge || "");
        }
      }
    }
  }, [registrationData.paymentType, isTransport, selectedRouteID, routes]);

  //useeffect to clear table
  useEffect(() => {
    setSelectedItems([]);
    setSelectedConcession("");
    setSelectedMonth("");
    setSelectedAmount("");

    if (registrationData.paymentType === "1") {
      setSelectedMonth("All");
    } else {
      setSelectedMonth("");
    }
    // Clear all transport-related state when payment type changes
    setSelectedRouteID("");  // Clear selected route
    setSelectedTransportItems([]);  // Clear transport items table
    setTransportAmount("");  // Clear amount field
    setTransportMonth("");  // Clear month selection
    setVehicles([]);  // Clear any assigned vehicles
    setRouteMessage("");  // Clear any route messages

    // Also update registrationData to clear routeId
    setRegistrationData(prev => ({
      ...prev,
      routeId: 0,
      studentAnualPack: ""  // Clear annual pack amount if it exists
    }));
  }, [registrationData.paymentType]);

 useEffect(() => {
  if (registrationData.countryId) fetchState();
  if (registrationData.stateId) fetchCity();
}, [registrationData.countryId, registrationData.stateId]);

useEffect(() => {
  if (registrationData.classId) {
    setRollNo([]);
    fetchddlSection();
  }
}, [registrationData.classId]);

useEffect(() => {
  if (registrationData.classId && registrationData.sectionId && rollNoMode === 'auto') {
    fetchRollno();
  }
}, [registrationData.classId, registrationData.sectionId, rollNoMode]);

  useEffect(() => {
    // Reset sectionId when classId changes
    setRegistrationData((prevData) => ({
      ...prevData,
      sectionId: "0", // Reset to initial state or set to the default value
    }));
  }, [registrationData.classId]);

  const fetchState = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlState`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          countryId: registrationData.countryId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setState(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchCity = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          stateId: registrationData.stateId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setCity(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchddlClass = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setddlClass(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchddlSection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/ClassPromotion/ddlSection_clsId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            teacherId: 0,
            classId: registrationData.classId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }

      const responseData = await response.json();

      if (
        responseData.data === null &&
        responseData.msg === "Record Not Found"
      ) {
        // Handle the case where no records are found
        console.warn("No records found for sections");
        // You can set a default value or perform any other necessary action
        // For example, setddlSection([]) if an empty array is expected
      } else {
        setddlSection(responseData);
        //setSelectedValue(responseData.data[0]); // Assuming the API returns an array of options
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRollno = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const clientCode = sessionStorage.getItem("clientCode");

      // Convert sectionId to number and ensure it's not empty/undefined
      const sectionId = registrationData.sectionId
        ? parseInt(registrationData.sectionId)
        : 0;

      // Convert classId to number as well for consistency
      const classId = registrationData.classId
        ? parseInt(registrationData.classId)
        : 0;

      // Only proceed if both classId and sectionId are valid numbers
      if (!classId || !sectionId) {
        console.warn("Class ID or Section ID is missing");
        return;
      }

      const endpoint = clientCode === "PTSS"
        ? "/Admission/GetNewRollNoWithCode"
        : "/Admission/GetNewRollNo";

      const response = await fetch(`${apiUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          classId: classId,
          sectionId: sectionId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Error fetching roll number: ${response.status}`);
      }

      const data = await response.json();

      // Check if the response indicates seats are exceeded
      if (Array.isArray(data) && data.length > 0) {
        if (data[0].newRollNo && data[0].newRollNo.includes("Seat Exceeded")) {
          setSeatExceeded(true);
          setRollNo(data[0].newRollNo);
        } else {
          setSeatExceeded(false);
          setRollNo(data[0].newRollNo);
        }
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error(error);
      setSeatExceeded(false);
    }
  };


 const checkDuplicateRollNo = async (rollNo) => {
  if (!rollNo || !rollNo.trim()) {
    setDuplicateRollNoMessage("");
    return;
  }
  if (!registrationData.classId || !registrationData.sectionId) return;

  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Admission/CheckDuplicateRollNo`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({
        classId: parseInt(registrationData.classId),
        sectionId: parseInt(registrationData.sectionId),
        rollNo: rollNo,
        sessionId: parseInt(registrationData.financialYearID),
      }),
    });
    const data = await response.json();
    setDuplicateRollNoMessage(data.message === "Roll number already exists." ? "Roll number is already taken." : "");
  } catch (error) {
    console.error("Error checking duplicate roll number:", error);
  }
}; 

  const fetchGender = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/ddlGender`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching roll number: ${response.status}`);
      }
      const data = await response.json();
      setGender(data); // Assuming the response contains the new roll number
    } catch (error) {
      console.error(error);
    }
  };

  const fetchBloodgrp = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/ddlBloodGroup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching roll number: ${response.status}`);
      }
      const data = await response.json();
      setBloodgrp(data); // Assuming the response contains the new roll number
    } catch (error) {
      console.error(error);
    }
  };

  const fetchConcession = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Concession/GetConcession`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setConcessionData(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchMonth = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Fine/GetMonthList`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }

      const data = await response.json();

      if (data.data === null && data.msg === "Record Not Found") {
        console.error("Record Not Found");
        return; // Exit the function if the record is not found
      }

      setMonth(data);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchCaste = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Caste/GetCaste`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`Error fetching caste data: ${response.status}`);
      }

      const data = await response.json();
      console.log("Caste API Response:", data);

      if (data.msg === "Record Not Found" || !data) {
        setCaste([]);
        console.error("Record Not Found or empty response");
        return;
      }

      // Handle both direct array and nested data cases
      const casteData = Array.isArray(data) ? data : data.data || [];
      setCaste(casteData);
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      setCaste([]);
    }
  };

  useEffect(() => {
    setSeatExceeded(false);
  }, [registrationData.classId, registrationData.sectionId]);


  useEffect(() => {
    fetchFinancialYears();
    fetchNationalityData();
    fetchReligionData();
    fetchCountry();
    fetchddlClass();
    fetchOcccupation();
    fetchBloodgrp();
    fetchGender();
    fetchConcession();
    fetchMonth();
    fetchCaste();
    fetchRoutes();
  }, []);

  const formattedDate = (rawDate) => {
    const selectedDate = new Date(rawDate);
    const day = selectedDate.getDate().toString().padStart(2, "0");
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, "0");
    const year = selectedDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const checkAdmissionNo = async (admissionNo) => {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const url = `${apiUrl}/Admission/CheckExistAdmissionNo`;
    const payload = { admissionNo };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.status === "Failed!") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          admissionNo: "Admission number is already taken",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          admissionNo: "",
        }));
      }
    } catch (error) {
      console.error("Error checking admission number:", error);
    }
  };

  const handleAdmissionNoChange = (e) => {
    const { value } = e.target;
    setRegistrationData((prevData) => ({
      ...prevData,
      admissionNo: value,
    }));
    if (value) {
      checkAdmissionNo(value);
    }
  };

  useEffect(() => {
    // Fetch the streams from the API using fetch
    const fetchStreams = async () => {
      try {
        const Url = process.env.REACT_APP_BASE_URL;
        const apiUrl = `${Url}/Stream/GetAllStreams`;
        const token = sessionStorage.getItem("token");
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ streamID: 0 }), // Initial payload: streamID = 0
        });
        const data = await response.json();

        // Check if the response contains the 'msg' key indicating no records
        if (data && data.msg === "No records found.") {
          setStreams([]); // Set streams to an empty array if no records found
        } else if (Array.isArray(data)) {
          setStreams(data); // If data is an array, set the streams
        } else {
          setStreams([]); // Handle unexpected response format
        }
      } catch (error) {
        console.error("Error fetching streams:", error);
        setStreams([]); // Handle error by setting streams to an empty array
      }
    };

    fetchStreams();
  }, []);

  // Close the dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  // Add this constant at the top of the component, after the imports or state declarations
  const notificationUrl = "https://wsmsv1.aidigitalsec.com/api/Notifications/PostAssignmentNotification";

  // Updated handleSave function
  const handleSave = async () => {

    if (duplicateRollNoMessage) {
  setDialogMessage("Roll number is already taken. Please choose a different one.");
  setOpenDialog(true);
  return;
}
    // Reset errors state
    setErrors({
      financialYearID: false,
      name: false,
      classId: false,
      sectionId: false,
      mobileNo: false,
      religionID: false,
      nationalityId: false,
      dob: false,
      age: false,
      fatherName: false,
      MotherName: false,
      FatheroccupationID: false,
      casteId: false,
      fatherMobile: false,
    });
    const mandatoryFields = {
      // financialYearID: !registrationData.financialYearID,
      name: !registrationData.name,
      classId: !registrationData.classId,
      sectionId: !registrationData.sectionId, // If section is mandatory
      dob: !registrationData.dob,
      // age: !registrationData.age,
      mobileNo:
        !registrationData.mobileNo || registrationData.mobileNo.length !== 10,
      fatherMobile:
        !registrationData.fatherMobile ||
        registrationData.fatherMobile.length !== 10,
      // MotherMobile:
      // registrationData.MotherMobile &&
      // registrationData.MotherMobile.length !== 10, // Optional, only validate if provided
      // religionID: !registrationData.religionID,
      // nationalityId: !registrationData.nationalityId,
      // casteId: !registrationData.casteId,
      fatherName: !registrationData.fatherName,
      MotherName: !registrationData.MotherName,
     rollNo: !rollNo?.trim()
      // FatheroccupationID: !registrationData.FatheroccupationID,
      // adharNO: !registrationData.adharNO || registrationData.adharNO.length !== 12,
    };
    const updatedErrors = Object.fromEntries(
      Object.entries(mandatoryFields).map(([key, isInvalid]) => [
        key,
        isInvalid ? (key.includes("Mobile") ? "Must be exactly 10 digits" : key.includes("adharNO") ? "Aadhar number must be of 12 digits" : "This field is required") : "",
      ])
    );
    setErrors(updatedErrors);
    const missingFieldsList = Object.entries(mandatoryFields)
      .filter(([_, isMissing]) => isMissing)
      .map(([fieldName]) => {
        // Map field names to more user-friendly labels
        const fieldLabels = {
          // financialYearID: "Session",
          name: "Student First Name",
          classId: "Class",
          sectionId: "Section",
          dob: "Date of Birth",
          // age: "Age",
          mobileNo: "Student Mobile No",
          fatherMobile: "Father's Mobile No",
          rollNo: "Roll No",
          // MotherMobile: "Mother's Mobile No",
          // religionID: "Religion",
          // nationalityId: "Nationality",
          // casteId: "Caste",
          fatherName: "Father Name",
          MotherName: "Mother Name",
          // FatheroccupationID: "Father's Profession",
          adharNO: "Aadhar No.",
        };
        return fieldLabels[fieldName] || fieldName;
      });
    // If there are missing fields, show them in the dialog
    if (missingFieldsList.length > 0) {
      setDialogMessage("Please fill all mandatory fields.");
      setMissingFields(missingFieldsList); // Store the list of missing fields
      setOpenDialog(true);
      return;
    }
    if (Object.values(mandatoryFields).some((field) => field)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        ...Object.fromEntries(
          Object.entries(mandatoryFields).map(([key, value]) => [
            key,
            value ? "This field is required" : "",
          ])
        ),
      }));
      setDialogMessage("Please fill all mandatory fields.");
      setOpenDialog(true);
      return;
    }
    setIsSaving(true);
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/Admission`;
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem("token");
      const userId = parseInt(sessionStorage.getItem("userId")) || 0;
      const clientName = sessionStorage.getItem("clientName") || "";
      const className =
        ddlClass.find((c) => c.classId === registrationData.classId)
          ?.className || "";
      const sectionName =
        ddlSection.find((s) => s.sectionId === registrationData.sectionId)
          ?.sectionName || "";
      const selectedStreamObject = streams.find(
        (stream) => stream.streamName === selectedStream
      );
      const streamId = selectedStreamObject ? selectedStreamObject.streamID : 0;
      const payload = {
        AdmissionNo: registrationData.admissionNo || "New",
        StudentLedgerNo: registrationData.StudentLedgerNo || "",
        admissionDate: formattedDate(registrationData.admissionDate),
        studentFirstName: registrationData.name || "",
        studentLastName: registrationData.lname || "",
        paymentType: parseInt(registrationData.paymentType) || 0,
        registrationId: registrationData.registrationId || 0,
        studentDOB: formattedDate(registrationData.dob) || "",
        studentAge: parseInt(registrationData.age) || 0,
        className,
        sectionName,
        rollNo: registrationData.newRollNo || rollNo || "",
        address: registrationData.address || "",
        emailId: registrationData.email || "",
        lastSchoolAttended: registrationData.lastSchoolAttended || "",
        trfCertificationNo: registrationData.CertiNo || "",
        studentAdhaarNo: registrationData.adharNO || "",
        languageType: selectedLanguageType || "",
        studentUserName: registrationData.studentUserName || "",
        studentMobile: registrationData.mobileNo || "",
        fetherMobile: registrationData.fatherMobile || "",
        sessionId: registrationData.financialYearID || "",
        classId: registrationData.classId || "",
        sectionId: registrationData.sectionId || "",
        isHostel: registrationData.isHostel,
        isTransport: registrationData.isTransport,
        isAdmissionNoManual: registrationData.isAdmissionNoManual,
        countryId: registrationData.countryId || "",
        routeId: registrationData.routeId || 0,
        pickAndDropLocationId: registrationData.pickAndDropLocationId || 0,
        religionId: registrationData.religionID || "",
        stateId: registrationData.stateId || "",
        cityId: registrationData.cityId || "",
        nationalityId: parseInt(registrationData.nationalityId) || 0,
        bloodGroupId: registrationData.bloodGroupId || "",
        genderId: registrationData.genderId || "",
        casteId: registrationData.casteId || 0,
        isEWS: registrationData.ews,
        streamId: streamId,
        studentAnualPack: registrationData.paymentType === "1" ? parseFloat(registrationData.studentAnualPack) || 0 : 0,
        concessionsDetail: selectedItems.map((item) => ({
          concessionId: item.concessionId,
          month: item.month,
          amount: item.amount,
        })),
        parentsDetails: {
          IsDob: parentsDobChecked,
          fatherName: registrationData.fatherName || "",
          fatherMobile: registrationData.fatherMobile || "",
          fatherEmail: registrationData.Femail || "",
          fatherAddress: registrationData.Faddress || "",
          fatherDob: parentsDobChecked ? formatDateMDY(registrationData.fdob) : "",
          fatherIncome: registrationData.FIncome || "",
          fatherAdhaarNo: registrationData.FAadhar || "",
          fatherOccupationId: registrationData.FatheroccupationID || 0, // Set to 0 if not selected
          motherName: registrationData.MotherName || "",
          motherMobile: registrationData.MotherMobile || "",
          motherEmail: registrationData.Memail || "",
          motherAddress: registrationData.Maddress || "",
          motherDob: parentsDobChecked ? formatDateMDY(registrationData.mdob) : "",
          motherIncome: registrationData.MIncome || "",
          motherAdhaarNo: registrationData.MAadhar || "",
          motherOccupation: registrationData.Motheroccupation || 0, 
          granfatherName: registrationData.grandFather || "",
        },
        //nabil
        transportDetails: selectedTransportItems.map((item) => ({
          routeId: item.routeId,
          monthId: item.monthId,
          routeCharges: item.amount,
          distance: item.distance,
        })),
        //nabil
       hostelDetails: selectedHostelItems.map((item) => ({
  roomNo: item.roomNo,
  hostelCharges: item.amount,
  monthId: item.monthId,      // was missing before
})),
      };
      const formData = new FormData();
      for (const key in payload) {
        if (key === "parentsDetails") {
          for (const subKey in payload[key]) {
            formData.append(`parentsDetails.${subKey}`, payload[key][subKey]);
          }
        } else if (key === "concessionsDetail") {
          payload[key].forEach((item, index) => {
            formData.append(
              `concessionsDetail[${index}].concessionTypeID`,
              item.concessionId
            );
            formData.append(`concessionsDetail[${index}].month`, item.month);
            formData.append(`concessionsDetail[${index}].Charge`, item.amount);
          });
        }
        else if (key === "transportDetails") {
          payload[key].forEach((item, index) => {
            formData.append(`transportDetails[${index}].routeId`, item.routeId);
            formData.append(`transportDetails[${index}].monthId`, item.monthId);
            formData.append(`transportDetails[${index}].routeCharges`, item.routeCharges);
            formData.append(`transportDetails[${index}].distance`, item.distance);
          });
        }
       else if (key === "hostelDetails") {
  payload[key].forEach((item, index) => {
    formData.append(`hostelDetails[${index}].roomNo`, item.roomNo);
    formData.append(`hostelDetails[${index}].hostelCharges`, item.hostelCharges);
    formData.append(`hostelDetails[${index}].monthId`, item.monthId);  // was sending month string before
  });
}
        else {
          formData.append(key, payload[key]);
        }
      }
      // Append file uploads
      if (registrationData.studentprofile)
        formData.append("StudentImgPath", registrationData.studentprofile);
      if (registrationData.StudentLedgerNo)
        formData.append("StudentLedgerNo", registrationData.StudentLedgerNo);
      if (registrationData.fatherprofile)
        formData.append("fatherImgPath", registrationData.fatherprofile);
      if (registrationData.motherprofile)
        formData.append("motherImgPath", registrationData.motherprofile);
      if (registrationData.aadharCardFront)
        formData.append(
          "adharFrontDocumentPath",
          registrationData.aadharCardFront
        );
      if (registrationData.aadharCardBack)
        formData.append(
          "adharBackDocumentPath",
          registrationData.aadharCardBack
        );
      if (registrationData.birthCertificate)
        formData.append(
          "birthCertificateDocumentPath",
          registrationData.birthCertificate
        );
      if (registrationData.transferCertificate)
        formData.append(
          "tranferDocumentPath",
          registrationData.transferCertificate
        );
      if (registrationData.others)
        formData.append("otherDocumentPath", registrationData.others);
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }
      const response = await fetch(`${apiUrl}?Branch_Id=${branchId}`, {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: formData,
      });
      const responseData = await response.json();
      if (response.ok) {
        // Send notification for the successfully added admission
        const message = `${clientName} added admission for ${registrationData.name}`;
        const notifBody = {
          userId,
          message,
          name: clientName
        };

        await fetch(notificationUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(notifBody),
        }).catch((err) => {
          console.error("Notification API Error:", err);
          // Optionally handle notification failure without blocking the success message
        });

        setShowSuccessModal(true);
        setLoadingBarProgress(100);
      } else {
        // alert(`Error: ${responseData.msg || "Failed to save data"}`);
        setSnackbarMessage(`Error: ${responseData.msg || "Failed to save data"}`);
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      setLoadingBarProgress(100);
      console.error("Error in handleSave:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }finally {
    setIsSaving(false);
}
  };

  useEffect(() => {
    // Calculate age when the date of birth changes
    calculateAge(registrationData.dob);
  }, [registrationData.dob]);

  const calculateAge = (dob) => {
    const dobDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();

    // Check if the birthday hasn't occurred yet this year
    if (
      today.getMonth() < dobDate.getMonth() ||
      (today.getMonth() === dobDate.getMonth() &&
        today.getDate() < dobDate.getDate())
    ) {
      age--;
    }

    // Update the age in the state
    setRegistrationData({ ...registrationData, age: age.toString() });
  };

  useEffect(() => {
    // Set the current date as default date on component mount
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
    setRegistrationData((prevData) => ({
      ...prevData,
      admissionDate: formattedDate,
    }));
  }, []);

  // Converts "YYYY-MM-DD" (date input value) to "MM/DD/YYYY"
const formatDateMDY = (value) => {
  if (!value) return "";
  const [year, month, day] = value.split("-");
  if (!year || !month || !day) return "";
  return `${day}/${month}/${year}`;   // dd/mm/yyyy
};

  return (
    <Container mt={5}>
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <AppBar
        position="static"
        style={{ backgroundColor: "#0B1F3D", marginBottom: "15px" }}
      >
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
            New Admission
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="financialYearLabel">Session</InputLabel>
              <Select
                labelId="financialYearLabel"
                id="financialYear"
                value={registrationData.financialYearID}
                label="Session"
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    financialYearID: e.target.value,
                  })
                }
                helperText={
                  errors.financialYearID ? (
                    <span style={{ color: "red" }}>Please Select Session</span>
                  ) : (
                    ""
                  )
                }
              >
                <MenuItem value="">
                  <em>Select year</em>
                </MenuItem>
                {financialYears.map((year) => (
                  <MenuItem
                    key={year.financialYearID}
                    value={year.financialYearID}
                  >
                    {year.finanacialYear}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            {isMaster && (
              <FormControl fullWidth>
                <InputLabel id="branch-label">Branch</InputLabel>
                <Select
                  labelId="branch-label"
                  id="branch"
                  value={selectedBranchId || ""}
                  label="Branch"
                  onChange={(e) => setSelectedBranchId(e.target.value)}
                >
                  <MenuItem value="">
                    <em>Select Branch</em>
                  </MenuItem>
                  {branches.map((branch) => (
                    <MenuItem key={branch.branchId} value={branch.branchId}>
                      {branch.branchName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Grid>

        </Grid>

        <Grid
          container
          spacing={3}
          alignItems="center"
          style={{ marginTop: "-5px" }}
        >
          <Grid item xs={12} sm={6}>
            <label htmlFor="registrationNo">
              <Typography variant="subtitle1">Registration No</Typography>
            </label>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                type="text"
                id="registrationNo"
                name="registrationNo"
                variant="outlined"
                fullWidth
                value={registrationData.registrationNo}
              //onChange={(e) => setRegistrationNo(e.target.value)}
              />
              <Button
                variant="outlined"
                onClick={fetchRegistration}
                style={{ marginLeft: "8px" }}
              >
                🔍
              </Button>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} marginTop="11px">
            {/* Registration Date */}
            <TextField
              id="registrationDate"
              label="Registration Date"
              type="date"
              variant="outlined"
              value={registrationData.dated}
              fullWidth
              onChange={(e) => {
                setRegistrationData({
                  ...registrationData,
                  dated: e.target.value,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginTop: "8px" }}
            />
          </Grid>

          <Grid item xs={12} sm={6} style={{ marginTop: "11px" }}>
            {/* Admission Date */}
            <TextField
              label="Admission Date"
              id="admissionDate"
              variant="outlined"
              type="date"
              value={registrationData.admissionDate}
              className="form-control"
              onChange={(e) => {
                const selectedDate = e.target.value;
                // No need to format the date here
                setRegistrationData({
                  ...registrationData,
                  admissionDate: selectedDate,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginTop: "8px" }} // Adjust the marginTop as needed
            />
          </Grid>
        </Grid>
      </Paper>
      <div>
        <AppBar
          position="static"
          style={{ backgroundColor: "#0B1F3D" }}
          className=" mt-4"
        >
          <Toolbar>
            <Typography variant="h5" component="div" style={{ fontWeight: "bold" }}>
              Student Details
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>

        <Grid
          container
          spacing={3}
          className="mt-3"
          style={{ marginTop: "-7px" }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
              <Typography variant="body2">Admission Number:</Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={admissionCodeMode === 'manual'}
                    onChange={(e) => {
                      const mode = e.target.checked ? 'manual' : 'auto';
                      setAdmissionCodeMode(mode);
                      setRegistrationData((prev) => ({
                        ...prev,
                        isAdmissionNoManual: mode === 'manual', // Set to true if manual, false if auto
                        admissionNo: mode === 'auto' ? '' : prev.admissionNo, // Clear admissionNo if auto
                      }));
                    }}
                  />
                }
                label="Enter Manually"
                sx={{ m: 0 }}
              />

            </Box>

            {admissionCodeMode === 'manual' && (
              <TextField
                label="Admission Code"
                variant="outlined"
                fullWidth
                name="admissionCode"
                value={registrationData.admissionNo}
                onChange={handleAdmissionNoChange}
                placeholder="Enter any admission number"
                sx={{ mb: 3, /* ...your existing sx styles... */ }}
                required
              />
            )}
            {admissionCodeMode === 'auto' && (
              <TextField
                fullWidth
                label="Admission No."
                id="admissionNo"
                value="New"
                //style={{backgroundColor: '#e3e3e3', color: 'red', marginTop: "10px"}}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    admissionNo: e.target.value,
                  })
                }
                InputProps={{
                  style: {
                    backgroundColor: "#e3e3e3", // Background color
                    color: "red", // Text color
                  },
                }}
              />)}

          </Grid>

          {/* <Grid item xs={6}>
            <TextField
              fullWidth
              label="Ledger No."
              id="ledgerNo"
              value={registrationData.StudentLedgerNo}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  StudentLedgerNo: e.target.value,
                })
              }
              type="number"
              InputProps={{
                inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                sx: {
                  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                },
              }}
            />
          </Grid> */}

          <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Student's Profile
  </Typography>
  <Input
    type="file"
    className="form-control-file"
    id="studentprofile"
    onChange={(e) => handleFileChange("studentprofile", e)}
  />
  <Typography variant="caption" color="textSecondary">
    Max size: 200KB
  </Typography>
</Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="First name*"
              id="firstName"
              // inputProps={{
              //     style: {
              //         width: "200px",
              //         height: "13px",
              //     },
              // }}
              value={registrationData.name}
              onChange={(e) =>
                setRegistrationData({ ...registrationData, name: e.target.value })
              }
              helperText={
                errors.name ? (
                  <span style={{ color: "red" }}>First name is required</span>
                ) : (
                  ""
                )
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last Name"
              id="lastName"
              value={registrationData.lname}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  lname: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="class">Class*</InputLabel>
              {/* <Select
              id="class"
            
              value={registrationData.classId}
              label="Class"
            
              onChange={handleClassChange}
          
            > */}
              <Select
                id="class"
                value={registrationData.classId}
                label="Class"
                onChange={handleClassChange}
                helperText={
                  errors.classId ? (
                    <span style={{ color: "red" }}>Class is required</span>
                  ) : (
                    ""
                  )
                }
              >
                <MenuItem value="">Select Class</MenuItem>
                {ddlClass.map((item) => (
                  <MenuItem key={item.classId} value={item.classId}>
                    {item.className}
                  </MenuItem>
                ))}
              </Select>
              {errors.classId && (
                <FormHelperText error>Class selection is required</FormHelperText>)}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="section">Section</InputLabel>
              {/* <Select
              id="section"
              value={registrationData.sectionId}
              label="Section"
              onChange={(e) => {
                handleSectionChange(e);
                
                fetchRollno();
              }}
            > */}
              <Select
                id="section"
                label="Section"
                value={registrationData.sectionId}
                onChange={(e) => {
                  handleSectionChange(e);
                  fetchRollno(); // Trigger fetchRollno when section is selected
                }}
              >
                <MenuItem value="0">Select Section</MenuItem>
                {ddlSection.map((item) => (
                  <MenuItem key={item.sectionId} value={item.sectionId}>
                    {item.sectionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="mt-3">
<Grid item xs={6}>
  {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
    <Typography variant="body2">Roll No:</Typography>
    <FormControl component="fieldset">
      <Grid container spacing={1}>
        <Grid item>
          <FormControlLabel
            control={
              <Radio
                checked={rollNoMode === 'manual'}
                onChange={() => {
                  setRollNoMode('manual');
                  setRollNo("");
                  setDuplicateRollNoMessage("");
                }}
                value="manual"
                name="rollNoMode-radio"
              />
            }
            label="Manual"
          />
        </Grid>
        <Grid item>
          <FormControlLabel
            control={
              <Radio
                checked={rollNoMode === 'auto'}
                onChange={() => setRollNoMode('auto')}
                value="auto"
                name="rollNoMode-radio"
              />
            }
            label="Auto Generate"
          />
        </Grid>
      </Grid>
    </FormControl>
  </Box> */}
  <TextField
    label="Roll No*"
    variant="outlined"
    id="rollNo"
    value={rollNo}
    disabled={rollNoMode === 'auto'}
    onChange={(e) => {
      if (rollNoMode === 'manual') {
        const value = e.target.value;
        setRollNo(value);
        if (value.trim() === "") {
          setDuplicateRollNoMessage("");
        } else {
          checkDuplicateRollNo(value);
        }
      }
    }}
    fullWidth
    error={!!errors.rollNo}
    helperText={errors.rollNo ? "Roll Number is required" : duplicateRollNoMessage || ""}
     FormHelperTextProps={{
    sx: { color: "red" }
  }}
  />
</Grid>
          <Grid item xs={12} sm={3}>
            <label htmlFor="dob">
              <TextField
                type="date"
                id="dob"
                label="D.O.B"
                variant="outlined"
                fullWidth
                value={registrationData.dob}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    dob: e.target.value,
                  })
                }
                helperText={
                  errors.dob ? (
                    <span style={{ color: "red" }}>
                      Please select date of birth
                    </span>
                  ) : (
                    ""
                  )
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </label>
          </Grid>
          <Grid item xs={12} sm={3}>
            <label htmlFor="age">
              <TextField
                type="text"
                id="age"
                label="Age"
                variant="outlined"
                fullWidth
                value={registrationData.age}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    age: e.target.value,
                  })
                }
                helperText={
                  errors.age ? (
                    <span style={{ color: "red" }}>Age is required</span>
                  ) : (
                    ""
                  )
                }
              />
            </label>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="nationality-label">Nationality</InputLabel>
              <Select
                labelId="nationality-label"
                id="nationality"
                label="Nationality"
                value={registrationData.nationalityId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    nationalityId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Nationality</MenuItem>
                {nationality.map((item) => (
                  <MenuItem key={item.nationalityId} value={item.nationalityId}>
                    {item.nationality}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="religion-label">Religion</InputLabel>
              <Select
                id="religion"
                //className="form-select"
                value={registrationData.religionID}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    religionID: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Religion</MenuItem>
                {religion.map((item) => (
                  <MenuItem key={item.religionID} value={item.religionID}>
                    {item.religionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Email Id"
              id="emailId"
              value={registrationData.email}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  email: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last School Attended"
              id="lastSchoolAttended"
              value={registrationData.lastSchoolAttended}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  lastSchoolAttended: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Certification No."
              id="certification No."
              value={registrationData.CertiNo}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  CertiNo: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Aadhar No."
              variant="outlined"
              fullWidth
              required
              value={registrationData.adharNO}
           onChange={(e) => {
  const value = e.target.value.replace(/\D/g, "");
  if (value.length <= 12) {
    setRegistrationData({
      ...registrationData,
      adharNO: value,
    });
  }
}}
              error={errors.adharNO}
              helperText="Aadhar number must be of 12 digits."
              inputProps={{
                maxLength: 12,
                inputMode: 'numeric', // Opens number keyboard on mobile
                pattern: '[0-9]*'      // Ensures only numbers (for some browsers)
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel id="gender-label">Gender</InputLabel>
              <Select
                labelId="gender-label"
                id="gender"
                label="Gender"
                value={registrationData.genderId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    genderId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Gender</MenuItem>
                {gender.map((item) => (
                  <MenuItem key={item.genderId} value={item.genderId}>
                    {item.gender}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Mobile No.*"
              id="mobileNo"
              value={registrationData.mobileNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                if (value.length <= 10) {
                  setRegistrationData({
                    ...registrationData,
                    mobileNo: value,
                  });
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    mobileNo:
                      value.length !== 10 ? "Must be exactly 10 digits" : "",
                  }));
                }
              }}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
              }}
              error={!!errors.mobileNo}
              helperText={errors.mobileNo || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="bloodgroup">Blood Group</InputLabel>
              <Select
                labelId="bloodgroup-label"
                id="bloodgroup"
                label="Blood Group"
                value={registrationData.bloodGroupId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    bloodGroupId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Blood Group</MenuItem>
                {bloodgrp.map((item) => (
                  <MenuItem key={item.bloodGroupId} value={item.bloodGroupId}>
                    {item.bloodGroupName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="country">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                label="Country"
                value={registrationData.countryId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    countryId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Country</MenuItem>
                {country.map((item) => (
                  <MenuItem key={item.countryId} value={item.countryId}>
                    {item.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="state">State</InputLabel>
              <Select
                labelId="state-label"
                id="state"
                label="State"
                value={registrationData.stateId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    stateId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select State</MenuItem>
                {state.map((item) => (
                  <MenuItem key={item.stateId} value={item.stateId}>
                    {item.stateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="city">City</InputLabel>
              <Select
                labelId="city-label"
                id="city"
                label="City"
                value={registrationData.cityId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    cityId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select City</MenuItem>
                {city.map((item) => (
                  <MenuItem key={item.cityId} value={item.cityId}>
                    {item.cityName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item md={6} sx={{ marginTop: 5 }}>
            <TextField
              id="address"
              label="Address"
              value={registrationData.address}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  address: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>

          <Grid item md={6} sx={{ marginTop: 5 }}>
            <FormControl fullWidth>
              <InputLabel htmlFor="paymentType">Payment Type</InputLabel>
              <Select
                label="Payment Type"
                id="paymentType"
                value={registrationData.paymentType}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    paymentType: e.target.value,
                  })
                }
              >
                <MenuItem value="0">General</MenuItem>
                {/* <MenuItem value="1">Annual</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {registrationData.paymentType === "1" && (
          <Grid container spacing={3}>
            <Grid item md={6} sx={{ marginTop: 5 }}>
              <TextField
                id="annualAmount"
                label="Annual Amount"
                value={registrationData.studentAnualPack} // Use studentAnualPack directly
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    studentAnualPack: e.target.value, // Update only studentAnualPack
                  })
                }
                fullWidth
              />
            </Grid>
          </Grid>
        )}

        <Grid container spacing={3} className="mt-3">
          <Grid item xs={6}>
            <FormControl fullWidth error={Boolean(errors.casteId)}>
              <InputLabel htmlFor="caste">Caste</InputLabel>
              <Select
                labelId="caste-label"
                id="caste"
                label="Caste"
                value={registrationData.casteId}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    casteId: e.target.value,
                  })
                }
              >
                <MenuItem value="">
                  <em>Select Caste</em>
                </MenuItem>
                {caste.length === 0 ? (
                  <MenuItem disabled>No caste records found</MenuItem>
                ) : (
                  caste.map((item) => (
                    <MenuItem key={item.casteId} value={item.casteId}>
                      {item.casteName}
                    </MenuItem>
                  ))
                )}
              </Select>
              {errors.casteId && (
                <Typography variant="caption" color="error">
                  Please select Caste
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Ledger No."
              id="ledgerNo"
              value={registrationData.StudentLedgerNo}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  StudentLedgerNo: e.target.value,
                })
              }
              type="number"
              InputProps={{
                inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                sx: {
                  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                },
              }}
            />
          </Grid>


          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              EWS
            </Typography>
            <FormControl component="fieldset">
              <Grid container spacing={2}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={registrationData.ews === "1"}
                        onChange={(e) =>
                          setRegistrationData({
                            ...registrationData,
                            ews: "1",
                          })
                        }
                        value="1"
                        name="ews-radio"
                      />
                    }
                    label="Yes"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={registrationData.ews === "0"}
                        onChange={(e) =>
                          setRegistrationData({
                            ...registrationData,
                            ews: "0",
                          })
                        }
                        value="0"
                        name="ews-radio"
                      />
                    }
                    label="No"
                  />
                </Grid>
              </Grid>
            </FormControl>
          </Grid>
        </Grid>

        {/* <div>
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark mt-4">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="/">
                            Parents Details
                        </a>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div
                            className="collapse navbar-collapse"
                            id="navbarSupportedContent"
                        >
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        </div>
                    </div>
                </nav>
            </div> */}
        { /* Transport-------------------------------------- */}
        <Typography variant="h6" gutterBottom className="mt-4">
          <b>Avail Transport</b>
        </Typography>

        <FormControl component="fieldset">
          <Grid container spacing={2}>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={isTransport === true}
                    onChange={() => {
                      setIsTransport(true);
                      setRegistrationData({
                        ...registrationData,
                        isTransport: true,
                      });
                    }}
                    name="transport"
                    color="primary"
                  />
                }
                label="Yes"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={isTransport === false}
                    onChange={() => {
                      setIsTransport(false);
                      setRegistrationData({
                        ...registrationData,
                        isTransport: false,
                        routeId: 0,
                      });
                    }}
                    name="transport"
                    color="primary"
                  />
                }
                label="No"
              />
            </Grid>
          </Grid>
        </FormControl>


        {isTransport && (
          <Grid container spacing={2} className="mt-6 items-center mb-6">
            <Grid item xs={12} md={12}>
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
                <Grid container spacing={2} alignItems="center">
                  {/* Route Selection - Always shown when transport is enabled */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="route-label">Select Route</InputLabel>
                      <Select
                        labelId="route-label"
                        id="route"
                        value={selectedRouteID || ""}
                        label="Select Route"
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          if (!selectedValue) {
                            setSelectedRouteID("");
                            setSelectedTransportItems([]);
                            setRegistrationData(prev => ({ ...prev, routeId: 0 }));
                            setRouteMessage("");
                            setVehicles([]);
                            setTransportAmount("");
                            return;
                          }

                          const selectedRoute = routes.find(
                            r => r.routeID === parseInt(selectedValue)
                          );

                          if (selectedRoute) {
                            setSelectedRouteID(selectedValue);
                            setRegistrationData(prev => ({
                              ...prev,
                              routeId: selectedRoute.routeID
                            }));
                            setRouteMessage(selectedRoute.message || "");
                            setVehicles(Array.isArray(selectedRoute.vehicles) ?
                              selectedRoute.vehicles : []);

                            // For both payment types, set the amount initially
                            const amount = registrationData.paymentType === "1"
                              ? selectedRoute.routeCharge * 12
                              : selectedRoute.routeCharge;

                            setTransportAmount(amount.toString());

                            if (registrationData.paymentType === "1") {
                              // For annual payment, set month to "All"
                              setTransportMonth("All");
                            }
                          }
                        }}
                      >
                        <MenuItem value="">Select Route</MenuItem>
                        {routes.map((route) => (
                          <MenuItem key={route.routeID} value={route.routeID}>
                            {route.routeName} - ({route.distance} km)
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Month Selection - Always shown but disabled for annual payment */}
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                      <InputLabel>Select Month</InputLabel>
                      <Select
                        value={transportMonth}
                        onChange={(e) => setTransportMonth(e.target.value)}
                        fullWidth
                        disabled={registrationData.paymentType === "1"} // Disable for annual
                      >
                        <MenuItem value="">Select Month</MenuItem>
                        <MenuItem value="All">All Months</MenuItem>
                        {month.map((item) => (
                          <MenuItem key={item.monthId} value={item.month}>
                            {item.month}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Amount Field - Always shown */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Amount"
                      type="number"
                      value={transportAmount}
                      onChange={(e) => setTransportAmount(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  {/* Add Button - Always shown */}
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAddTransportItem}
                      disabled={
                        !selectedRouteID ||
                        !transportMonth ||
                        !transportAmount ||
                        isNaN(transportAmount)
                      }
                      fullWidth
                      style={{
                        height: '56px',
                        color: "white",
                        backgroundColor: "#ED6C02"
                      }}
                    >
                      +
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            {/* Transport Items Table */}
            {selectedTransportItems.length > 0 && (
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Serial No</TableCell>
                        <TableCell>Selected Route</TableCell>
                        <TableCell>Month</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedTransportItems.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.routeName} ({item.distance} km)</TableCell>
                          <TableCell>
                            {item.month === "All" ? "All months" : item.month}
                          </TableCell>
                          <TableCell>
                            {item.amount}
                            {registrationData.paymentType === "0" && item.month === "All" &&
                              ` (12 × ${item.amount / 12})`}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => handleDeleteTransportItem(index)}
                              style={{
                                color: "white",
                                backgroundColor: "#9C27B0"
                              }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/* Assigned Vehicles Table */}
            {vehicles.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="h6">Assigned Vehicles</Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Vehicle Reg No</TableCell>
                        <TableCell>Fuel Type</TableCell>
                        <TableCell>Capacity</TableCell>
                        <TableCell>Model</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vehicles.map((vehicle, index) => (
                        <TableRow key={index}>
                          <TableCell>{vehicle.registrationNo}</TableCell>
                          <TableCell>{vehicle.fuelType}</TableCell>
                          <TableCell>{vehicle.seatingCapicity}</TableCell>
                          <TableCell>{vehicle.model}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        )}


        <Typography variant="h6" gutterBottom className="mt-4">
          <b>Avail Hostel</b>
        </Typography>

        <FormControl component="fieldset">
          <Grid container spacing={2}>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={isHostel}
                    onChange={(e) => {
                      setIsHostel(e.target.checked);
                      setRegistrationData({
                        ...registrationData,
                        isHostel: e.target.checked,
                      });
                    }}
                    name="hostel"
                    color="primary"
                  />
                }
                label="Yes"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={!isHostel}
                    onChange={() => {
                      setIsHostel(false);
                      setRegistrationData({
                        ...registrationData,
                        isHostel: false,
                      });
                    }}
                    name="hostel"
                    color="primary"
                  />
                }
                label="No"
              />
            </Grid>
          </Grid>
        </FormControl>

        {isHostel && (
          <Grid container spacing={2} className="mt-6 items-center mb-6">
            <Grid item xs={12} md={12}>
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={3}>
  <TextField
    label="Room No"
    value={hostelRoomNo}
    onChange={(e) => setHostelRoomNo(e.target.value)}
    fullWidth
  />
</Grid>
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="hostel-month-label">Select Month</InputLabel>
                      <Select
                        labelId="hostel-month-label"
                        id="hostel-month"
                        value={hostelMonth}
                        onChange={(e) => setHostelMonth(e.target.value)}
                        label="Select Month"
                        disabled={registrationData.paymentType === "1"}
                      >
                        <MenuItem value="">Select Month</MenuItem>
                        <MenuItem value="All">All Months</MenuItem>
                        {month.map((item) => (
                          <MenuItem key={item.monthId} value={item.month}>
                            {item.month}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      label="Amount"
                      type="number"
                      value={hostelAmount}
                      onChange={(e) => setHostelAmount(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAddHostelItem}
                      disabled={
                        !hostelMonth ||
                        !hostelAmount ||
                        isNaN(hostelAmount)
                      }
                      fullWidth
                      style={{
                        height: '56px',
                        color: "white",
                        backgroundColor: "#ED6C02"
                      }}
                    >
                      +
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            {selectedHostelItems.length > 0 && (
              <Grid item xs={12} mt={2}>
                <TableContainer component={Paper}>
                  <Table>
                  <TableHead>
  <TableRow>
    <TableCell>Serial No</TableCell>
    <TableCell>Room No</TableCell> {/* ADD THIS */}
    <TableCell>Month</TableCell>
    <TableCell>Amount</TableCell>
    <TableCell>Action</TableCell>
  </TableRow>
</TableHead>

                    <TableBody>
                      {selectedHostelItems.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.roomNo}</TableCell> 
                          <TableCell>
                            {item.month === "All" ? "All months" : item.month}
                          </TableCell>
                          <TableCell>
                            {item.amount}
                            {registrationData.paymentType === "0" && item.month === "All" &&
                              ` (12 × ${item.amount / 12})`}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => handleDeleteHostelItem(index)}
                              style={{
                                color: "white",
                                backgroundColor: "#9C27B0"
                              }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        )}

      </Paper>
      <div>
        <AppBar
          position="static"
          style={{ backgroundColor: "#0B1F3D" }}
          className="mt-4"
        >
          <Toolbar>
            <Typography variant="h5" component="div" style={{ fontWeight: "bold" }}>
              Parents Details
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Father Name"
              id="name"
              value={registrationData.fatherName}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fatherName: e.target.value,
                })
              }
              helperText={
                errors.name ? (
                  <span style={{ color: "red" }}>Father name is required</span>
                ) : (
                  ""
                )
              }
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Mother Name"
              id="name"
              value={registrationData.MotherName}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  MotherName: e.target.value,
                })
              }
              helperText={
                errors.name ? (
                  <span style={{ color: "red" }}>Mother name is required</span>
                ) : (
                  ""
                )
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Father's Mobile No.*"
              id="fmobileNo"
              value={registrationData.fatherMobile}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                if (value.length <= 10) {
                  setRegistrationData({
                    ...registrationData,
                    fatherMobile: value,
                  });
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    fatherMobile:
                      value.length !== 10 ? "Must be exactly 10 digits" : "",
                  }));
                }
              }}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
              }}
              error={!!errors.fatherMobile}
              helperText={errors.fatherMobile || ""}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={copyStudentMobile}
                  onChange={handleCopyStudentMobileChange}
                />
              }
              label="Same as Student's Mobile Number"
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Mother's Mobile No."
              id="mmobileNo"
              value={registrationData.MotherMobile}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // Allow only digits
                if (value.length <= 10) {
                  setRegistrationData({
                    ...registrationData,
                    MotherMobile: value,
                  });
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    MotherMobile:
                      value.length !== 10 && value.length > 0
                        ? "Must be exactly 10 digits"
                        : "",
                  }));
                }
              }}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
              }}
              error={!!errors.MotherMobile}
              helperText={errors.MotherMobile || ""}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Email Id"
              id="femailId"
              value={registrationData.Femail}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  Femail: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Email Id"
              id="memailId"
              value={registrationData.Memail}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  Memail: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="profession">Profession</InputLabel>
              <Select
                id="profession"
                value={registrationData.FatheroccupationID}
                label="Profession"
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    FatheroccupationID: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Occupation</MenuItem>
                {occupation.map((item) => (
                  <MenuItem key={item.occupationID} value={item.occupationID}>
                    {item.occupationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="profession">Profession</InputLabel>
              <Select
                id="profession"
                value={registrationData.Motheroccupation}
                label="Profession"
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    Motheroccupation: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Occupation</MenuItem>
                {occupation.map((item) => (
                  <MenuItem key={item.occupationID} value={item.occupationID}>
                    {item.occupationName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Guardian's Name"
              id="name"
              value={registrationData.grandFather}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  grandFather: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Father's Income"
              id="Fincome"
              value={registrationData.FIncome}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  FIncome: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Mother's Income"
              id="mothersIncome"
              value={registrationData.MIncome}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  MIncome: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        {/* <Grid container spacing={3} className="mt-3">
        <Grid item md={6}>
          <TextField
            fullWidth
            label="Income"
            id="Fincome"
            value={registrationData.fathersIncome}
            onChange={(e) =>
              setRegistrationData({
                ...registrationData,
                fathersIncome: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item md={6}>
          <TextField
            fullWidth
            label="Income"
            id="mothersIncome"
            value={registrationData.mothersIncome}
            onChange={(e) =>
              setRegistrationData({
                ...registrationData,
                mothersIncome: e.target.value,
              })
            }
          />
        </Grid>
      </Grid> */}
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
           <TextField
  fullWidth
  label="Aadhar No."
  id="fatherAadharNo"
  value={registrationData.FAadhar}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 12) {
      setRegistrationData({
        ...registrationData,
        FAadhar: value,
      });
    }
  }}
  inputProps={{
    maxLength: 12,
    inputMode: 'numeric',
    pattern: '[0-9]*',
  }}
  helperText="Aadhar number must be of 12 digits."
/>
          </Grid>
          <Grid item md={6}>
           <TextField
  fullWidth
  label="Aadhar No."
  id="motherAadharNo"
  value={registrationData.MAadhar}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 12) {
      setRegistrationData({
        ...registrationData,
        MAadhar: value,
      });
    }
  }}
  inputProps={{
    maxLength: 12,
    inputMode: 'numeric',
    pattern: '[0-9]*',
  }}
  helperText="Aadhar number must be of 12 digits."
/>
          </Grid>
        </Grid>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={parentsDobChecked}
                onChange={() => setParentsDobChecked(!parentsDobChecked)}
                id="defaultCheck1"
              />
            }
            label={<b>Parents DOB</b>}
            style={{ marginTop: "20px" }}
          />

          {parentsDobChecked && (
            <Grid container spacing={2} className="mt-3">
              <Grid item xs={6}>
                <TextField
                  id="fatherDob"
                  label="Father's DOB"
                  type="date"
                  value={registrationData.fdob}
                  onChange={(e) =>
                    setRegistrationData({
                      ...registrationData,
                      fdob: e.target.value,
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }} // Add this line
                  style={{ marginBottom: "20px" }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="motherDob"
                  label="Mother's DOB"
                  type="date"
                  value={registrationData.mdob}
                  onChange={(e) =>
                    setRegistrationData({
                      ...registrationData,
                      mdob: e.target.value,
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }} // Add this line
                  style={{ marginBottom: "20px" }}
                />
              </Grid>
            </Grid>
          )}
        </div>

        {/* Father's Address Field with Checkbox */}
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Father's Address"
              id="faddress"
              value={registrationData.Faddress}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  Faddress: e.target.value,
                })
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={copyStudentAddressForFather}
                  onChange={handleCopyStudentAddressForFatherChange}
                />
              }
              label="Same as Student's Address"
            />
          </Grid>
        </Grid>

        {/* Mother's Address Field with Checkbox */}
        <Grid container spacing={3} className="mt-3">
          <Grid item md={6}>
            <TextField
              fullWidth
              label="Mother's Address"
              id="maddress"
              value={registrationData.Maddress}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  Maddress: e.target.value,
                })
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={copyStudentAddressForMother}
                  onChange={handleCopyStudentAddressForMotherChange}
                />
              }
              label="Same as Student's Address"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mt-3">
        <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Father's Profile
  </Typography>
  <Input
    type="file"
    id="fatherprofile"
    onChange={(e) => handleFileChange("fatherprofile", e)}
    fullWidth
  />
  <Typography variant="caption" color="textSecondary">
    Max size: 200KB
  </Typography>
</Grid>

<Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Mother's Profile
  </Typography>
  <Input
    type="file"
    id="motherprofile"
    onChange={(e) => handleFileChange("motherprofile", e)}
    fullWidth
  />
  <Typography variant="caption" color="textSecondary">
    Max size: 200KB
  </Typography>
</Grid>
        </Grid>

        <Grid container spacing={2} className="mt-3">
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom className="mt-4">
              <b>Choose Stream</b>
            </Typography>

            <FormControl fullWidth>
              <InputLabel id="stream-label">Stream</InputLabel>
              <Select
                labelId="stream-label"
                id="stream"
                label="Stream"
                value={selectedStream}
                onChange={(e) => setSelectedStream(e.target.value)}
              >
                <MenuItem value="">Select Stream</MenuItem>
                {streams.length === 0 ? (
                  <MenuItem disabled>No streams available</MenuItem>
                ) : (
                  streams.map((stream) => (
                    <MenuItem key={stream.streamID} value={stream.streamName}>
                      {stream.streamName}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={2} className="mt-2">
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom className="mt-2">
              <b>Choose Language</b>
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="language-type-label">Language Type</InputLabel>
              <Select
                labelId="language-type-label"
                id="language-type"
                label="Language Type"
                value={selectedLanguageType}
                onChange={(e) => setSelectedLanguageType(e.target.value)}
              >
                <MenuItem value="">Select Language Type</MenuItem>
                <MenuItem value="Hindi">Hindi</MenuItem>
                <MenuItem value="English">English</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {/* Dialog for displaying error */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Error</DialogTitle>
          <DialogContent>
            <Typography variant="body1">{dialogMessage}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>


        {/* Concession Details starts here */}
        <Typography variant="h6" gutterBottom className="mt-4">
          <b>Concession Details</b>
        </Typography>

        <Grid container spacing={2} className="mt-6 items-center mb-6">
          <Grid item xs={12} md={12}>
            <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="concession-label">Concession</InputLabel>
                    <Select
                      labelId="concession-label"
                      id="concession"
                      value={selectedConcession}
                      onChange={(e) => setSelectedConcession(e.target.value)}
                      label="Concession"
                    >
                      <MenuItem value="">Select Concession Type</MenuItem>
                      {concessionData.map((item) => (
                        <MenuItem key={item.concessionId} value={item.concessionName}>
                          {item.concessionName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                    <InputLabel id="month-label">Select Month</InputLabel>
                    <Select
                      labelId="month-label"
                      id="month"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      label="Select Month"
                      disabled={registrationData.paymentType === "1"}
                    >
                      <MenuItem value="">Select Month</MenuItem>
                      <MenuItem value="All">All Months</MenuItem>
                      {month.map((item) => (
                        <MenuItem key={item.monthId} value={item.month}>
                          {item.month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    label="Amount"
                    type="number"
                    value={selectedAmount}
                    onChange={(e) => setSelectedAmount(e.target.value)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddItem}
                    disabled={
                      !selectedConcession ||
                      !selectedMonth ||
                      !selectedAmount ||
                      isNaN(selectedAmount)
                    }
                    fullWidth
                    style={{
                      height: '56px',
                      color: "white",
                      backgroundColor: "#ED6C02",
                    }}
                  >
                    +
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>

          {selectedItems.length > 0 && (
            <Grid item xs={12} mt={2}>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Serial No</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Concession Type</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Month</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedItems.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.concession}</TableCell>
                        <TableCell>
                          {registrationData.paymentType === "1" ? "All Months" : item.month}
                        </TableCell>
                        <TableCell>
                          {item.amount}
                          {registrationData.paymentType === "0" && item.month === "All" &&
                            ` (12 × ${item.amount / 12})`}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleDeleteItem(index)}
                            style={{
                              color: "white",
                              backgroundColor: "#9C27B0"
                            }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
        </Grid>



        {/* Concession Details ends here */}

        {/* <Typography variant="h6" className="mt-3">
        <b>Avail Transport</b>
      </Typography>

      <Grid container spacing={2} className="mt-3">
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox
                checked={isTransport}
                onChange={handleTransportChange}
              />
            }
            label={
              <Typography variant="body1">
                <b>Is Transport</b>
              </Typography>
            }
            style={{ marginLeft: "10px" }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} className="mt-3">
        <Grid item md={6}>
          <FormControl fullWidth>
            <InputLabel htmlFor="route">Route</InputLabel>
            <Select
              id="route"
              value={registrationData.fathersOccupationId}
              label="Route"
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fathersOccupationId: e.target.value,
                })
              }
            >
              <MenuItem value="lightOptionValue">Select Route</MenuItem>
              <MenuItem value="option1">A</MenuItem>
              <MenuItem value="option2">B</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item md={6}>
          <FormControl fullWidth>
            <InputLabel htmlFor="route">
              Select Pick and Drop location
            </InputLabel>
            <Select
              id="route"
              value={registrationData.mothersOccupationId}
              label="Select Pick and Drop location"
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  mothersOccupationId: e.target.value,
                })
              }
            >
              <MenuItem value="lightOptionValue">Select Pick and Drop</MenuItem>
              <MenuItem value="option1">B</MenuItem>
              <MenuItem value="option2">C</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid> */}

        {/* <Grid container spacing={2} className="mt-3">
        <Grid item>
          <FormControlLabel
            control={
              <Checkbox checked={isHostel} onChange={handleHostelChange} />
            }
            label={
              <Typography variant="body1">
                <b>Is Hostel</b>
              </Typography>
            }
            style={{ marginLeft: "10px" }}
          />
        </Grid>
      </Grid> */}

        {/* <div className="col-md-6">
<label htmlFor="route" className="form-label">
Route
</label>
<select
id="route"
className="form-select"
value={selectedValue}
onChange={(e) => setSelectedValue(e.target.value)}
>
<option value="lightOptionValue">Select Route</option>
<option value="option1">A</option>
<option value="option2">B</option>
</select>
</div>
<div className="col-md-6">
<label htmlFor="profession" className="form-label">
Select Pick and Drop location
</label>
<select
id="profession"
className="form-select"
value={selectedValue}
onChange={(e) => setSelectedValue(e.target.value)}
>
<option value="lightOptionValue">Select Pick and Drop</option>
<option value="option1">B</option>
<option value="option2">C</option>
</select>
</div> */}
        <Typography variant="h6" className="mt-3">
  <b>Document</b>
  <Typography variant="caption" color="textSecondary" component="span" sx={{ ml: 1 }}>
    (Max size: 200KB per file)
  </Typography>
</Typography>

        <Grid container spacing={3}>
          {/* Aadhar Card Front */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              Aadhar Card Front
            </Typography>
            <form>
              <div className="form-group">
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Input
                  type="file"
                  className="form-control-file"
                  id="aadharCardFront"
                  onChange={(e) => handleFileChange("aadharCardFront", e)}
                />
              </div>
            </form>
          </Grid>

          {/* Aadhar Card Back */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              Aadhar Card Back
            </Typography>
            <form>
              <div className="form-group">
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Input
                  type="file"
                  className="form-control-file"
                  id="aadharCardBack"
                  onChange={(e) => handleFileChange("aadharCardBack", e)}
                />
              </div>
            </form>
          </Grid>

          {/* Birth Certificate */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              Birth Certificate
            </Typography>
            <form>
              <div className="form-group">
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Input
                  type="file"
                  className="form-control-file"
                  id="birthCertificate"
                  onChange={(e) => handleFileChange("birthCertificate", e)}
                />
              </div>
            </form>
          </Grid>

          {/* Transfer Certificate */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              Transfer Certificate
            </Typography>
            <form>
              <div className="form-group">
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Input
                  type="file"
                  className="form-control-file"
                  id="transferCertificate"
                  onChange={(e) => handleFileChange("transferCertificate", e)}
                  required
                />
              </div>
            </form>
          </Grid>

          {/* Others */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" gutterBottom>
              Others
            </Typography>

            <form>
              <div className="form-group">
                <Typography variant="subtitle1" gutterBottom></Typography>
                <Input
                  type="file"
                  className="form-control-file"
                  id="others"
                  onChange={(e) => handleFileChange("others", e)}
                />
              </div>
            </form>
          </Grid>
        </Grid>
      </Paper>

      <div
        className="mt-3 row"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div className="col-md-">
        <Tooltip
  title={
    seatExceeded
      ? "Cannot Save: Seats exceeded for this class/section"
      : duplicateRollNoMessage
      ? "Cannot Save: Roll number is already taken"
      : ""
  }
  arrow>
  <span>
    <button
      type="button"
      className="mt-2 mx-2 btn btn-primary"
      onClick={handleSave}
      disabled={seatExceeded || !!duplicateRollNoMessage || isSaving}
      style={{
        width: "100px",
        height: "50px",
        padding: "10px 0",
        fontWeight: 'bold',
        opacity: seatExceeded || !!duplicateRollNoMessage || isSaving ? 0.6 : 1,
        cursor: seatExceeded || !!duplicateRollNoMessage || isSaving ? 'not-allowed' : 'pointer'
      }}
    >
      <b>{isSaving ? "Saving..." : "Save"}</b>
    </button>
  </span>
</Tooltip>
          <button
            type="button"
            className="mt-2 mx-2 btn btn-danger"
            onClick={resetForm} // Add onClick handler
            style={{
              width: "100px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}
          >
            <b>Reset</b>
          </button>
        </div>
      </div>

      {/* Modal for displaying fetched data */}
      <Dialog open={showModal} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle style={{ backgroundColor: "#3498db", color: "#fff" }}>
          Registration Details
        </DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Registration No</TableCell>
                  <TableCell>Student Name</TableCell>
                  <TableCell>Registration Date</TableCell>
                  <TableCell>Mobile No</TableCell>
                  <TableCell>Action</TableCell>{" "}
                  {/* New column for the action button */}
                </TableRow>
              </TableHead>
              <TableBody>
                {regisData.map((registration) => (
                  <TableRow key={registration.registrationId}>
                    <TableCell>{registration.registrationNo}</TableCell>
                    <TableCell>{registration.name}</TableCell>
                    <TableCell>{registration.dated}</TableCell>
                    <TableCell>{registration.mobileNo}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() =>
                          handleRowSelection(
                            registration,
                            registration.registrationId
                          )
                        }
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions style={{ borderTop: "none" }}>
          <Button onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialog Popup for mandatory field error */}
      {/* Dialog Popup for mandatory field error */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          sx: {
            width: 400,
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: 24,
          },
        }}
      >
        {/* Custom Header */}
        <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
          <Typography variant="h6" sx={{ color: '#fff' }}>
            Missing Fields
          </Typography>
        </Box>

        {/* Content Area */}
        <DialogContent sx={{ padding: '20px' }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {dialogMessage || 'Please fill in the following required fields:'}
          </Typography>
          <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
            {missingFields.map((field, index) => (
              <li key={index}>
                <Typography variant="body2">- {field}</Typography>
              </li>
            ))}
          </ul>

          {/* Action Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              onClick={() => setOpenDialog(false)}
              variant="contained"
              color="primary"
            >
              OK
            </Button>
          </Box>
        </DialogContent>
      </Dialog>


     <Modal
  open={showSuccessModal}
  onClose={(_, reason) => {
    if (reason !== "backdropClick") setShowSuccessModal(false);
  }}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Admission Done ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Admission for this student is successful.
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default AddAdmission;